module.exports = __webpack_public_path__ + "img/HC1015-25.e429eac2.jpg";